import React from "react";
import "./Starter.css";
import img from "../../Assets/image1.jpeg";
import logo from "../../Assets/Logo.png";
import Footer from "../../Layout/Footer/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTwitter,
  faDiscord,
  faInstagram,
  faSpotify,
} from "@fortawesome/free-brands-svg-icons";
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";
function Starter({ func }) {
  return (
    <>
      <div className="starter">
        <div className="starter_top">
          <div className="starter_boxes">
          <a href="https://open.spotify.com/artist/5thXj1ppNP3P7xUhuF476N" target="_blank"><FontAwesomeIcon icon={faSpotify} /> </a>
          <a href="https://twitter.com/mystical_pets" target="_blank"><FontAwesomeIcon icon={faTwitter} /></a>
          <a href="https://discord.gg/wT78pzNJJh" target="_blank"><FontAwesomeIcon icon={faDiscord} /></a>
          <a href="https://www.instagram.com/mysticalpets_nft/?hl=en" target="_blank"><FontAwesomeIcon icon={faInstagram} /></a>
          </div>
        </div>
        <div className="middle-starter">
          <img src={logo} alt="..." className="logo-enter" />
          <img src={img} alt="" />
          <div className="left_starter">
            <div className="left_left">
              <div className="h1-start">
                <h1>Welcome to the</h1>
                <h1 style={{ alignSelf: "center", marginLeft: "-25px" }}>
                  Home of
                </h1>
                <h1>Mystical Pets</h1>
              </div>

              <button
                onClick={() => {
                  func(false);
                }}
                className="enter"
              >
                Enter
              </button>
            </div>
            <div className="right_right">
              <p className="scroll_text">Scroll Down</p>
              <FontAwesomeIcon icon={faLongArrowAltDown} />
            </div>
          </div>
        </div>
        <p className="desc-starter">
          A limited NFT collection where the virtual goods meet reality, come
          join us and discover <br></br> the story of the Mystical Pets
        </p>
        <p className="desc-starters">
          Open this website on a desktop for the best experience
        </p>
      </div>
      <Footer prop={false} />
      <div className="bottom-line"></div>
    </>
  );
}

export default Starter;
